<script>
import TheDrawerMinifier from '@components/layout/the-drawer-minifier.vue'
import baseMixin from '@/mixins/baseMixin'
import navMixin from '@/mixins/navMixin'
import { mapGetters } from 'vuex'
import { LogoForm } from '@/shared/constants/assets/LogoForm'
import { LogoShade } from '@/shared/constants/assets/LogoShade'
import BaseLogo from '../_base-logo.vue'
import TheCreateBookingBtn from './the-create-booking-btn.vue'

export default {
  name: 'TheNavDrawer',
  components: {
    TheDrawerMinifier,
    BaseLogo,
    TheCreateBookingBtn,
  },
  mixins: [baseMixin, navMixin],
  props: {
    drawer: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    isMini() {
      return !this.isMobileViewPort && this.mini
    },
    compLogoForm() {
      return this.isMini ? LogoForm.ICON : LogoForm.NONE
    },
    compShade() {
      return this.isDarkMode ? LogoShade.LIGHT : LogoShade.DARK
    },
  },
  methods: {
    handleDrawer(event) {
      if (this.isMobileViewPort) return this.$emit('setDrawerState', event)
    },
    convertToActiveIcon(icon) {
      const strSplit = icon.split('-outline')
      return strSplit[0]
    },
  },
}
</script>

<template>
  <v-navigation-drawer
    id="main-navigation-drawer"
    app
    :hide-overlay="!isMobileViewPort"
    :value="drawer"
    bottom
    :temporary="isMobileViewPort"
    :mini-variant="isMini"
    disable-route-watcher
    :class="['nav-drawer sidebar', !isDarkMode ? 'grey lighten-5' : '']"
    @input="handleDrawer($event)"
  >
    <v-list flat class="sidebar-nav indigo--text">
      <div v-for="{ icon, title, to, key } in navItems" :key="key">
        <v-tooltip :disabled="!isMini" right>
          <template v-slot:activator="{ on }">
            <v-list-item
              :to="to"
              :title="title"
              :aria-label="title"
              exact
              link
              color="primary"
              v-on="on"
            >
              <v-list-item-icon>
                <BaseIcon
                  :color="isActiveNavItem(to) ? 'blue' : ''"
                  :name="isActiveNavItem(to) ? convertToActiveIcon(icon) : icon"
                  :shade="compShade"
                ></BaseIcon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="subtitle-2">
                  {{ title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ title }}</span>
        </v-tooltip>
      </div>
    </v-list>
    <template v-slot:prepend>
      <div style="height: 72px;" class="d-flex align-center justify-center">
        <BaseLogo
          :width="isMini ? '25' : '120'"
          :form="compLogoForm"
          :shade="compShade"
        />
      </div>

      <TheCreateBookingBtn :mini="isMini" />
    </template>
    <template v-if="!isMobileViewPort" v-slot:append>
      <TheDrawerMinifier />
    </template>
  </v-navigation-drawer>
</template>
